import PortfolioCreationContainer from "./PortfolioCreationContainer";
import PortfolioCreationStore from "./PortfolioCreationStore";

export default PortfolioCreationStore(PortfolioCreationContainer);